import * as React from 'react';
import camelCase from 'lodash/camelCase';

import { IInputProps } from '../../common';
import { useFocusControl } from '../../../Utils';
import { ENTERKEY, ENTERKEY_ATL } from '../../../Utils/events/keyCodes';

import { ToggleButton, ToggleInput, ToggleLabel, ToggleSlidingIndicator, ToggleWrap } from './RadioToggleStyles';

export interface IInputRadioToggleField extends IInputProps {
  value: string;
}

// exporting here is a work around for this issue https://github.com/microsoft/tslint-microsoft-contrib/issues/667
export const InputRadioToggleField =
  React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement> & IInputRadioToggleField>((
  {
    children,
    inputProps,
    value
  },
  ref
) => {
  const { clickFocus, stopClickFocus, resetClickFocus } = useFocusControl();

  const inputId: string = camelCase(`${value} id`);

  const handleEnterPress: (e: React.KeyboardEvent<HTMLInputElement>) => void = e => {
    if (e.key === ENTERKEY || e.key === ENTERKEY_ATL) {
      e.currentTarget.click();
    }
  };

  return (
    <ToggleWrap>
      <ToggleInput
        id={inputId}
        ref={ref}
        value={value}
        onKeyPress={handleEnterPress}
        type='Checkbox'
        clickFocus={clickFocus}
        onBlur={resetClickFocus}
        {...inputProps}
      />
        <ToggleLabel htmlFor={inputId} onMouseDown={stopClickFocus}>
          {children}
          <ToggleButton>
            <ToggleSlidingIndicator />
          </ToggleButton>
        </ToggleLabel>
    </ToggleWrap>
  );
});

export default InputRadioToggleField;
